import { type Biome } from '@goodtime/shared';

export interface BiomeBackgroundEffectsProps {
  biomeId: Biome['id'];
}

/**
 * L3 (background) idle effects dispatcher.
 *
 * <p>Mounted inside {@code MapLayerBackground}'s panorama-sized
 * wrapper. L3 scrolls slowest (0.25×), so this is the right home for
 * sky-attached effects — aurora, distant lightning, etc. Currently
 * only frost has an L3 effect.
 */
export function BiomeBackgroundEffects(_props: BiomeBackgroundEffectsProps) {
  return null;
}
